import { fetchConToken } from "../../../helpers/fetch"
import { handleErrorApi } from "../../../helpers/randoms";
import { types } from "../../../types/types";
import { startAlerta } from "../../ui/alertas";
import { startSpinner, finishSpinner } from "../../ui/spinner";


export const FetchPlazos = () => async (dispatch) => {
    
    try {
        const response = await fetchConToken(`Plazos`);
        const body = await response.json();

        if (response.ok) {
            dispatch({
                type: types.abmTraerPlazosSuccess,
                payload: body
            })
        }else {
            throw body;
        }
    } catch (error) {
        handleErrorApi(dispatch, error, "Error al cargar los plazos.", "Ha ocurrido un error. Intente Nuevamente")
        dispatch({type: types.abmPlazosError})
    }

}


export const BuscarPlazos = (text) => (dispatch) =>{
    dispatch({
        type : types.abmBuscarPlazos,
        payload : text
    });
}

export const agregarPlazos = (tipoPlazo, dias, descripcion) => async (dispatch) => {
    try {
        dispatch(startSpinner());

        let datos = {
            tipoPlazo: tipoPlazo,
            descripcion: descripcion,
            dias: dias
        }

        const response = await fetchConToken(`Plazos`, datos, "POST");
        const body = await response.json();

        if (response.ok) {
            dispatch(startAlerta("Plazo creado correctamente", 'success', 'Comando Exitoso'))
            dispatch(finishSpinner());
            dispatch(FetchPlazos());
            
        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner());
        handleErrorApi(dispatch, error, "Error al crear un plazo.", "Ha ocurrido un error. Intente nuevamente")
    }
};

export const ModificarPlazos = (id ,dias, descripcionPlazo) => async (dispatch) => {
    try {
        dispatch(startSpinner());
        let datos = {
            dias: dias,
            descripcion: descripcionPlazo
        }
        
        const response = await fetchConToken(`Plazos/${id}`, datos, "PUT");
        const body = await response.json();

        if (response.ok) {
            dispatch(startAlerta("Plazo modificado correctamente", 'success', 'Comando Exitoso'))
            dispatch(finishSpinner());
            dispatch(FetchPlazos());
        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner());
        handleErrorApi(dispatch, error, "Error al modificar el Plazo.", "Ha ocurrido un error. Intente nuevamente")
    }
};

export const EliminarPlazo = (id) => async (dispatch) => {
    try {
        dispatch(startSpinner());

        const response = await fetchConToken(`Plazos/${id}`, '', "DELETE");
        const body = await response.json(); 

        if(response.ok){
            dispatch(startAlerta("Plazo eliminado correctamente", 'success', 'Comando Exitoso'))
            dispatch(finishSpinner());
            dispatch(FetchPlazos());
        }else{
            throw body; 
        }
    } catch (error) {
        dispatch(finishSpinner());
        handleErrorApi(dispatch, error, "Error al eliminar el Plazo.", "Ha ocurrido un error. Intente nuevamente")
    }
};

